import { baseApi, TAG } from '../../app/api/baseApi'
const readRefreshToken = (data) => (data && data.refreshToken ? data.refreshToken : data) || ''
export const accountApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        registerClient: builder.mutation({
            query: () => ({ url: '/Account/Client', method: 'POST', body: {} }),
            extraOptions: { token: 'id' }
        }),
        // By client id, not /Client/ClientRefreshToken: that one only admits the Client group, so
        // invited Owners and Admins (ClientUser group) could not reach the token they are allowed to see.
        getIntegrationToken: builder.query({
            query: (clientId) => `/Client/${clientId}/RefreshToken`,
            transformResponse: readRefreshToken,
            providesTags: [TAG.INTEGRATION_TOKEN]
        }),
        deleteIntegrationToken: builder.mutation({
            query: (clientId) => ({ url: `/Client/${clientId}/RefreshToken`, method: 'DELETE' }),
            invalidatesTags: [TAG.INTEGRATION_TOKEN]
        }),
        checkUserToken: builder.mutation({
            query: () => ({ url: '/User/Token/Check', method: 'GET' })
        }),
        getUserAuthorizeUrl: builder.mutation({
            query: () => ({ url: '/User/Authorize', method: 'GET' })
        })
    })
})

export const {
    useGetIntegrationTokenQuery,
    useDeleteIntegrationTokenMutation,
    useCheckUserTokenMutation,
    useGetUserAuthorizeUrlMutation
} = accountApi
